import { apiSlice } from "../../apiSlice";
import { Note } from "../../../types/modulesInterfaces";
export interface NotesCreatePayload {
	content: string | null;
	module_type_id?: number;
	module_id: number;
	project_id: number;
}

export interface NotesUpdatePayload {
	id: number;
	content: string | null;
	project_id: number;
}

export interface NotesDeletePayload {
	id: number;
}

// Re-export types from createGenericOperationsApi for backward compatibility
export type { GetDefaultProps, GetModuleTypesPayload } from "./createGenericOperationsApi";

// Create queries and mutations API slice
const notesApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getNoteById: builder.query<Note, { module_type: number, project_id: number }>({
			query: ({ module_type, project_id }) => `notes/?module_type=${module_type}&module_id=${project_id}`,
			providesTags: (_result, _error, { project_id }) => [{ type: 'ModuleNotes', id: project_id }],
			transformResponse: (response: Note[]) => response[0],
		}),
		deleteModuleNotes: builder.mutation<Note, { id: number, project_id: number }>({
			query: ({ id }) => {
				return {
					url: `notes/${id}/`,
					method: "DELETE",
				}
			},
			invalidatesTags: (_result, _error, { project_id }) => [
				{ type: 'ModuleNotes', project_id },
			],
		}),
		createModuleNotes: builder.mutation<Note, NotesCreatePayload>({
			query: (body) => {
				return {
					url: "notes/",
					method: "POST",
					body,
				};
			},
			invalidatesTags: (_result, _error, { project_id }) => [
				{ type: 'ModuleNotes' as const, id: project_id },
			],
		}),
		updateModuleNotes: builder.mutation<Note, NotesUpdatePayload>({
			query: ({ id, content }) => {
				return {
					url: `notes/${id}/`,
					method: "PATCH",
					body: { content }
				};
			},
			invalidatesTags: (_result, _error, { project_id }) => [
				{ type: 'ModuleNotes', project_id },
			],
		}),
	})
});

// Export query and mutation hooks
export const {
	useGetNoteByIdQuery,
	useUpdateModuleNotesMutation,
	useCreateModuleNotesMutation,
	useDeleteModuleNotesMutation,
} = notesApiSlice;

export const notesEndpoints = notesApiSlice.endpoints;

// Re-export query hooks from createGenericOperationsApi for backward compatibility
export {
	useGetModuleResultsByGasQuery,
	useGetModuleHistoryQuery,
	useGetSubmoduleDefaultsQuery,
	useGetModuleTypesQuery,
	useGetModuleTypeByIdQuery,
	useGetDefaultCountryQuery,
	useGetModuleByIdQuery,
} from "./createGenericOperationsApi";
